import axios from 'axios';
import { API } from '@/config/api';

const state = {
  groups: [],
}

const getters = {
  getGroups: (state) => state.groups,
}

const mutations = {
  setGroups: (state, groups) => {
    state.groups = groups;
  },
}

const actions = {
  async fetchGroups({ commit }) {
    try {
      const response = await axios.post(
        API.GET_GROUPS,
        {
          "token": "test",
          "limit": 50,
          "page": 0
        }
      );

      if (response.status === 200) {
        commit('setGroups', response.data.response.groups);
        
      } else {
        
      }
    } catch (error) {
      console.error('Error fetching groups:', error);
    }
  },
}

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
}
